export enum EChartObservationUnit {
  BREATHS_PER_MIN = '{breaths}/min',
  CENTIMETER = 'cm',
  DEGREES_CELSIUS = 'Cel',
  DEGREES_FAHRENHEIT = '[degF]',
  HEARTBEATS_PER_MIN = '{beats}/min',
  INCH = '[in_i]',
  KILOGRAM = 'kg',
  MILLIMETERS_OF_MERCURY = 'mm[Hg]',
  MILLIGRAMS_PER_DECILITER = 'mg/dL',
  MILLIMOLES_PER_LITER = 'mmol/L',
  PERCENT = '%',
  POUND = '[lb_av]',
}
